// extracted by mini-css-extract-plugin
export default {"main":"No2_main__qdZPO"};